import Swiper from 'swiper';
// import Swiper, { Navigation, Pagination, Autoplay, Parallax } from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, HashNavigation, Keyboard } from 'swiper/modules';
// import 'swiper/css';
import 'swiper/css/effect-fade';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';
// import 'swiper/css/parallax';

export default () => {
      

    let i;
    let galleries = document.getElementsByClassName('gallery');
    for (i=0; i < galleries.length; i++) {
        console.log('galleryGO');

        let galleryType = galleries[i].getAttribute('data-galleryType');

        if (galleryType == 'hoverFade') {
                    let theid = galleries[i].getAttribute('data-id');
                    let mainElement = '#gallery-' + theid;
                    let next = '.swiper-button-next-' + theid;
                    let prev = '.swiper-button-prev-' + theid;
                    let pag = '.swiper-pagination-' + theid;
                    let thedelay = 500;
                    let swiper = new Swiper(mainElement, {
                        modules: [Navigation, Pagination, Autoplay, EffectFade],
                        loop: true,
                        init: false,
                        effect: 'fade',
                        crossFade: true,
                        autoplay: {
                            delay: thedelay,
                        },
                        preloadImages: false,
                        speed: 300,
                        parallax: true,
                        slidesPerView: 1,
                        watchSlidesVisibility: true,
                        // loopedSlides: swiperlength,
                        centeredSlides: true,
                        spaceBetween: 0,
                        // If we need pagination
                        pagination: {
                            el: pag,
                        },
                        navigation: {
                            nextEl: next,
                            prevEl: prev,
                        }, 
                    });

                    galleries[i].addEventListener('mouseover', function (e) {swiper.autoplay.start()});
                    galleries[i].addEventListener('mouseout', function (e) {swiper.autoplay.stop()});

                    

                    swiper.on('afterInit', function() {
                        console.log('Gallery gone');
                        swiper.autoplay.stop();

                    });
                    swiper.init();

        } else if (galleryType == 'rollingSlider') {

            let theid = galleries[i].getAttribute('data-id');
                    let mainElement = '#gallery-' + theid;
                    let next = '.swiper-button-next-' + theid;
                    let prev = '.swiper-button-prev-' + theid;
                    let pag = '.swiper-pagination-' + theid;
                    let thedelay = 500;
                    let swiper = new Swiper(mainElement, {
                        modules: [Navigation, Pagination, Autoplay, EffectFade, HashNavigation, Keyboard],
                        loop: true,
                        init: false,
                        // effect: 'fade',
                        // crossFade: true,
                        preloadImages: false,
                        speed: 600,
                        keyboard: true,
                        parallax: true,
                        hashNavigation: { 
                            watchState: true
                        },
                        slidesPerView: 1,
                        watchSlidesVisibility: true,
                        // loopedSlides: swiperlength,
                        centeredSlides: true,
                        spaceBetween: 0,
                        // If we need pagination
                        pagination: {
                            el: pag,
                        },
                        navigation: {
                            nextEl: next,
                            prevEl: prev,
                        }, 
                    });

                    

                    function slideHasChangedDownload() {
                        let downloadLink = document.getElementById('theDownloadLink');
            
                                let currentslideindex = swiper.activeIndex;
                            
                                let thecurrentslide = swiper.slides[currentslideindex];
            
                                let downloadLinkData = thecurrentslide.getAttribute("data-download");
                                downloadLink.setAttribute('href', downloadLinkData)

                                let artist = thecurrentslide.getAttribute('data-artist');
                                let thetitle = thecurrentslide.getAttribute('data-title');
                                let artistDiv = document.getElementById('sliderArtist');
                                let titleDiv = document.getElementById('sliderTitle');
                                let artistUrl = thecurrentslide.getAttribute('data-artisturl');
                                if (artist.length > 0) {
                                    artistDiv.innerHTML = artist;
                                    // titleDiv.innerHTML = ' — ' + thetitle;
                                    artistDiv.setAttribute('href', artistUrl);
                                    console.log(artistUrl)
                                } else {
                                    artistDiv.innerHTML = artist;
                                    // titleDiv.innerHTML = thetitle;
                                    artistDiv.setAttribute('href', ' ');
                                }

                                let currentNum = thecurrentslide.getAttribute('data-number');
                                let counterDiv = document.getElementById('currentNum-' + theid);
                                counterDiv.innerHTML = currentNum;

                    }

                    let downloadWindowButton = document.getElementById('sliderDownloadLink');
                    downloadWindowButton.addEventListener('click', () => {
                        let theWindow = document.getElementById('sliderDownloadWindow');
                        theWindow.classList.remove('hidden');
                        setTimeout(() => {theWindow.classList.remove('opacity-0')}, 200);
                    })

                    let downloadWindowClose = document.getElementById('downloadWindowClose');
                    downloadWindowClose.addEventListener('click', () => {
                        let theWindow = document.getElementById('sliderDownloadWindow');
                        theWindow.classList.add('opacity-0');
                        setTimeout(() => {theWindow.classList.add('hidden')}, 700);
                    })
                    

                    swiper.on('afterInit', function() {
                        console.log('Gallery gone');
                        slideHasChangedDownload();

                    });
                    swiper.init();

                    swiper.on('slideChange', function() {
                        slideHasChangedDownload(); 
                    });



                    let gal;
                    let clickers = document.getElementsByClassName('openGallery');
                    if(clickers.length > 0) {
                        for (gal=0; gal < clickers.length; gal++ ) {
                            clickers[gal].addEventListener('click', function (event) {
                                let gallery = document.getElementsByClassName('rollingGallery')[0];
                                gallery.classList.remove('hidden');
                                let hash = event.target.closest('.openGallery').getAttribute('data-hash');
                                // console.log(hash);
                                let slide = document.getElementById('rollingSlide--' + hash);
                                window.location.hash = hash;
                                let theSlideIndex = slide.getAttribute('data-swiper-slide-index');
                                // setTimeout(function() {swiper.slideTo(theSlideIndex)}, 2000);
                                console.log(theSlideIndex);
                            })
                        }
                    }

                    if(window.location.hash != "" && window.location.hash != null && window.location.hash != "-") {
                        let gallery = document.getElementsByClassName('rollingGallery')[0];
                                gallery.classList.remove('hidden');
                    }

        } else if (galleryType == 'inlineSlider') {
            let theid = galleries[i].getAttribute('data-id');
            let mainElement = '#gallery-' + theid;
            let next = '.swiper-button-next-' + theid;
            let prev = '.swiper-button-prev-' + theid;
            let pag = '.swiper-pagination-' + theid;
            let thedelay = 500;
            let swiper = new Swiper(mainElement, {
                modules: [Navigation, Pagination, Autoplay, EffectFade, HashNavigation],
                loop: true,
                init: false,
                preloadImages: false,
                speed: 300,
                parallax: true,
                slidesPerView: 1,
                watchSlidesVisibility: true,
                // loopedSlides: swiperlength,
                centeredSlides: true,
                spaceBetween: 0,
                // If we need pagination
                pagination: {
                    el: pag,
                },
                navigation: {
                    nextEl: next,
                    prevEl: prev,
                }, 
            });


            

            swiper.on('afterInit', function() {
                console.log('Gallery gone');

            });
            swiper.init();

        };
        
        // swiper.on('slideChange', function() {
            
        // });

       
        


    };

};